(function($){
$('.podcast-expand-toggle-on').on('click', function(e){
    e.preventDefault();
    
    var $podcast = $(this).parents('.podcast-wrapper');
    
    $('.short-desc', $podcast).addClass('hidden');
    $('.long-desc', $podcast).removeClass('hidden');
    $('.podcast-expand-toggle-off', $podcast).removeClass('hidden');
    
    $(this).addClass('hidden');
});
$('.podcast-expand-toggle-off').on('click', function(e){
    e.preventDefault();
    
    var $podcast = $(this).parents('.podcast-wrapper');
    
    $('.short-desc', $podcast).removeClass('hidden');
    $('.long-desc', $podcast).addClass('hidden');
    $('.podcast-expand-toggle-on', $podcast).removeClass('hidden');
    
    $(this).addClass('hidden');
});
})(jQuery);